import api from '../api/offlineClient';
import connectivity from '../utils/connectivity';
import { getQueue, removeFromQueue } from '../utils/syncQueue';

class SyncService {
  constructor() {
    this.isSyncing = false;
    this.listeners = [];

    connectivity.subscribe(({ online, event }) => {
      if (online && event === 'reconnected') {
        this.syncNow();
      }
    });
  }

  async syncNow() {
    if (this.isSyncing) return;
    this.isSyncing = true;
    this._notify({ isSyncing: true, queued: 0, completed: 0 });

    try {
      const pending = getQueue();
      if (!pending.length) {
        this._notify({ isSyncing: false, status: 'synced', queued: 0, completed: 0 });
        return;
      }

      let completed = 0;
      for (const item of pending) {
        try {
          await api.request({
            method: item.method.toLowerCase(),
            url: item.url,
            data: item.data ? (typeof item.data === 'string' ? JSON.parse(item.data) : item.data) : undefined,
          });
          removeFromQueue(item.id);
          completed++;
          this._notify({ isSyncing: true, queued: pending.length, completed });
        } catch (err) {
          console.error('[sync] error en item:', item.url, err.message);
        }
      }

      this._notify({ isSyncing: false, status: 'synced', queued: pending.length, completed });

      // Notify pages so they can reload fresh data from server
      if (completed > 0) {
        window.dispatchEvent(new CustomEvent('sgv:synced', { detail: { completed } }));
      }
    } catch (err) {
      console.error('[sync] error general:', err.message);
      this._notify({ isSyncing: false, status: 'error', error: err.message });
    } finally {
      this.isSyncing = false;
    }
  }

  subscribe(callback) {
    this.listeners.push(callback);
    return () => { this.listeners = this.listeners.filter(cb => cb !== callback); };
  }

  _notify(data) {
    this.listeners.forEach(cb => cb(data));
  }
}

const syncService = new SyncService();
export default syncService;
